module.exports = __webpack_public_path__ + "static/media/adam-paclt.a3c007a6.jpg";